import React from "react";

import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const HelpIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue887'}</MuiIcon>
        );
    })
